import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Warning } from "../../../../components/Icons/Icons";
import { confirmRegulatorySubmissionPatientConsents } from "../../../../api/clinicalTrial";
import { Success } from "../../../../components/Notifications/Notifications";
import { HandleApiError } from "../../../../components/Notifications/APIErrorHandler";

export const MissingConsents = ({
  protocolId,
  patientId,
  missingConsents,
  setMissingConsents,
}) => {
  const [consentRejected, setConsentRejected] = useState(null);
  const [rejectedReason, setRejectedReason] = useState();
  const [confirmingConsent, setConfirmingConsent] = useState(false);

  useEffect(() => {
    // Si hay algún consentimiento rechazado, lo informo

    if (!missingConsents?.length) return;

    const rejectedItem = missingConsents.find((x) => x.rejected);

    if (rejectedItem && consentRejected === null) {
      setConsentRejected(true);
      setRejectedReason(rejectedItem.rejectedReason);
    }
  }, [missingConsents]);

  const { t } = useTranslation();

  const handleConfirmConsent = async () => {
    try {
      setConfirmingConsent(true);
      const result = await confirmRegulatorySubmissionPatientConsents(
        protocolId,
        patientId,
        consentRejected,
        rejectedReason
      );

      if (result.status === 200) {
        // limpio los consentimientos tanto si acepta como si rechaza
        // para habilitar los botones de guardar y publicar
        setMissingConsents([]);
        Success(
          "protocolNotifications.visitTracking_confirmPatientConsentRegulatorySubmission"
        );
      }
    } catch (error) {
      HandleApiError(error);
    } finally {
      setConfirmingConsent(false);
    }
  };

  const rejectedReasonIsEmpty = !rejectedReason || !rejectedReason.trim();

  return (
    <>
      {!missingConsents && <></>}
      {!!missingConsents.length && (
        <Row>
          <Col md={12}>
            <div
              className="alert alert-warning"
              role="alert"
              style={{ marginBottom: 16 }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <Warning />{" "}
                <strong>
                  {t(
                    "protocolNotifications.visitTracking_patientConsentsWarningTitle"
                  )}
                </strong>
              </div>
              <p style={{ marginBottom: 8 }}>
                {t(
                  "protocolNotifications.visitTracking_patientConsentsMessage"
                )}
              </p>
              <div style={{ margin: "8px 0" }}>
                {missingConsents.map((s) => (
                  <div key={s.id}>&bull; {s.title}</div>
                ))}
              </div>

              <div style={{ marginTop: 10 }}>
                <div style={{ marginBottom: 8 }}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="consent-response"
                      id="consent-accepted"
                      checked={consentRejected === false}
                      onChange={() => setConsentRejected(false)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="consent-accepted"
                      style={{ marginLeft: 6 }}
                    >
                      {t(
                        "protocolNotifications.visitTracking_patientConsentsAccepted"
                      )}
                      {/* Ej: "El paciente ACEPTÓ el consentimiento" */}
                    </label>
                  </div>

                  <div className="form-check" style={{ marginTop: 4 }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="consent-response"
                      id="consent-rejected"
                      checked={consentRejected === true}
                      onChange={() => setConsentRejected(true)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="consent-rejected"
                      style={{ marginLeft: 6 }}
                    >
                      {t(
                        "protocolNotifications.visitTracking_patientConsentsRejected"
                      )}
                      {/* Ej: "El paciente RECHAZÓ el consentimiento" */}
                    </label>
                  </div>
                </div>

                {consentRejected === true && (
                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <label
                      className="form-label"
                      htmlFor="rejected-reason"
                      style={{ fontWeight: 600 }}
                    >
                      {t(
                        "protocolNotifications.visitTracking_patientConsentsRejectedReason"
                      )}
                    </label>

                    <textarea
                      id="rejected-reason"
                      className="form-control"
                      rows={3}
                      value={rejectedReason}
                      onChange={(e) => setRejectedReason(e.target.value)}
                      placeholder={t(
                        "protocolNotifications.visitTracking_patientConsentsRejectedReasonPlaceholder"
                      )}
                    />

                    {rejectedReasonIsEmpty && (
                      <small
                        className="text-danger"
                        style={{ display: "block", marginTop: 6 }}
                      >
                        {t(
                          "protocolNotifications.visitTracking_patientConsentsRejectedReasonRequired"
                        )}
                      </small>
                    )}
                  </div>
                )}

                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  disabled={
                    consentRejected === null ||
                    confirmingConsent ||
                    (consentRejected === true && rejectedReasonIsEmpty)
                  }
                  onClick={handleConfirmConsent}
                >
                  {confirmingConsent
                    ? t(
                        "protocolNotifications.visitTracking_confirmingConsentMessage"
                      )
                    : t(
                        "protocolNotifications.visitTracking_confirmPatientConsentButton"
                      )}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};
